import { learningApi } from 'services/api'
import { IQuestionBookItemsToPrint } from '../types'

interface IStudentProps {
  _id: string
  name: string
  email: string
}

export const RENAME_QUESTION_BOOK = async (questionBookId: string, text: string) => {
  const token = localStorage.getItem('token')
  try {
    await learningApi.patch(
      `/question/books/${questionBookId}`,
      { name: text },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const GET_QUESTION_BOOK_ITEMS = async (
  questionBookId: string
): Promise<IQuestionBookItemsToPrint[]> => {
  const token = localStorage.getItem('token')
  try {
    const response = await learningApi.get(`/question/books/${questionBookId}/items/download`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response?.data
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const COPY_QUESTION_BOOK = async (
  questionBookId: string,
  student: IStudentProps,
  text: string
) => {
  const token = localStorage.getItem('token')
  try {
    await learningApi.post(
      `/question/books/copy/${questionBookId}`,
      {
        student: {
          _id: student._id,
          name: student.name,
          email: student.email,
        },
        name: text,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const DELETE_QUESTION_BOOK = async (questionBookId: string) => {
  const token = localStorage.getItem('token')
  try {
    await learningApi.delete(`/question/books/${questionBookId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  } catch (err) {
    console.log(err)
    throw err
  }
}
